import React from "react"
import { Bookmark } from "react-feather"
import { useProfile } from "../../contexts/ProfileContextProvider"

const LikeButton = React.memo(
    ({ data, isFavorite, optionalColor, size = 36 }) => {
        // Hämta funktion att sätta favorit från ProfileContextProvider
        const { contextSetFavorites } = useProfile()

        function handleClick(e) {
            e.stopPropagation()
            contextSetFavorites(data)
        }

        return (
            <button onClick={handleClick}>
                <Bookmark
                    size={size}
                    strokeWidth={1.5}
                    className={`transition-all ease-in-out duration-200 active:scale-90  ${
                        isFavorite
                            ? "text-primary-500 fill-primary-500 hover:text-primary-600 hover:fill-primary-600"
                            : "fg-color-1"
                    }`}
                />
            </button>
        )
    },
    (prevProps, nextProps) => {
        return (
            prevProps.isFavorite === nextProps.isFavorite &&
            prevProps.data.monternummer === nextProps.data.monternummer
        )
    },
)

export default LikeButton

//TODO!!!
//safe area insets för modal -welcome
//animation transition för modal -welcome
//welcome picture to svg
//welcome picture animation

//fix sorting option
//fix display active filters
